export const embeddedMiddleware = () => (next) => (action) => {
  if (action?.action) {
    return next(action.action);
  }
  return next(action);
};
